import { LoadingOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import spacing from "../../ui/spacingConfig";

type Props = {
  message: string;
};

const FormLoadingMessage: React.FC<Props> = ({ message }) => {
  return (
    <Row
      align="middle"
      style={{ margin: "4em 0", width: "100%" }}
      gutter={spacing.s}
    >
      <Col>
        <LoadingOutlined />
      </Col>
      <Col>
        <p>{message}</p>
      </Col>
    </Row>
  );
};

export default FormLoadingMessage;
